<template>
  <div></div>
</template>

<script>
import axios from "axios";

export default {
  name: "Auth",

  props: {
    msg: String,
  },

  data: function () {
    return {
      items: [],
      poiId: this.$route.params.poiId,
      token: this.$route.params.token,
      tokenKey: this.$appTokenKey,
    };
  },

  created: function () {
    this.writeAuthToken();
    this.$router.push({ name: "SubdepList", params: { gotoMain: true } });
  },

  methods: {
    writeAuthToken: function () {
      window.localStorage.setItem(this.tokenKey, this.token);
    },
  },
};
</script>

<style scoped>
</style>
